module.exports = __webpack_public_path__ + "img/Iran, Islamic Rep..a7c7c6fe.gif";